import { apiFetchWithoutAuth } from "../utils/api";

export const completeBookkeepingOAuthApi = async (
  integrationType: string,
  code: string,
  state: string,
): Promise<void> => {
  return apiFetchWithoutAuth(
    `callback/bookkeeping/integration/${integrationType}/oauth2`,
    { method: "POST", body: { code, state } }
  );
};

